import { toast } from "react-toastify";

// Actions
export const openToast = (params) => { 
    
    toast[params.type](params.message, {className: `r-toast-${params.type}`});
   
};